import { createGroupBookingsAPIClient } from '@/infrastructure/groups/api/groupBookingsAPIClient';

export const groupBookingsAPIClient = createGroupBookingsAPIClient({});
